import React from 'react';
// Components
import FaqComponent from './FaqComponent';
import SocialMediaCtaComponent from '../socialMedia/SocialMediaCtaComponent';
// Images
import MainImage from '../../assets/images/gallery/lc14.webp'
import { CompanyName } from '../../utils/Constants';
function FaqPageMainContainer() {
  return (
    <main role='main' className='grid w-full bg-colour2 text-colour1'>
      <section className='grid px-6 py-12 md:px-10 lg:px-16'>
        <FaqComponent />
      </section>

      <section>
        <div className='grid overflow-hidden'>
          <img
            src={MainImage}
            alt={`${CompanyName} — portrait`}
            className='h-[50vh] md:h-[60vh] w-auto object-cover mx-auto'
            loading='lazy'
            decoding='async'
          />
        </div>
      </section>

      <SocialMediaCtaComponent />
    </main>
  );
}

export default FaqPageMainContainer;
